import { worldNodeArt } from './world-node-art';
import './world-node-art.css';

export function WorldNodeArt({
  kind,
  className = '',
  state,
  decorative = true,
}: {
  kind?: string;
  className?: string;
  state?: string;
  decorative?: boolean;
}) {
  const art = worldNodeArt(kind);
  return (
    <span className={`world-node-art ${className}`} data-state={state} data-artwork={art.id}>
      <img
        src={art.url}
        alt={decorative ? '' : art.label}
        width={512}
        height={512}
        decoding="async"
      />
    </span>
  );
}
